import { User } from '../models';
import { auth, googleProvider } from '../../firebase';
import { getCookieByName, setCookie } from '../../utils';

const state = {
  data: new User(),
  error: null,
};

const getters = {
  isUserAuthenticated() {
    return getCookieByName('accessToken');
  },
  signInError(state) {
    return state.error;
  },
};

const actions = {
  async signIn({ commit, dispatch }) {
    try {
      const data = await auth.signInWithPopup(googleProvider);
      const payload = { user: data.user, token: data.credential.accessToken };
      setCookie('accessToken', data.credential.accessToken);
      setCookie('uid', data.user.uid);
      setCookie('user', JSON.stringify(payload));
      commit('SAVE_USER', payload);
      await dispatch('_init');
      await dispatch('fetchContactGroups');
    } catch (e) {
      commit('ADD_ERROR', e.message);
      commit('SAVE_SIGNIN_ERROR', e.code);
    }
  },
  async signOut({ commit }) {
    await auth.signOut();
    commit('CLEAR_USER');
    commit('CLEAR_CONTACTS');
    setCookie('accessToken', '');
    setCookie('uid', '');
    setCookie('user', '');
  },
};

const mutations = {
  SAVE_USER(state, payload) {
    state.data = new User(payload.user, payload.token);
  },
  CLEAR_USER(state) {
    state.data = new User();
  },
  SAVE_SIGNIN_ERROR(state, payload) {
    state.error = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js